module.exports = {
	"config": {
		"siteTitle": "Enhanced Interiors Remodeling",
		"linkPrefix": "/gatsby-starter-default"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about-us.md",
				"ext": "md",
				"name": "about-us",
				"extname": ".md",
				"basename": "about-us.md",
				"dirname": "",
				"stem": "about-us",
				"path": "about-us.md"
			},
			"requirePath": "about-us.md",
			"path": "/about-us/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "thanks.js",
				"ext": "js",
				"name": "thanks",
				"extname": ".js",
				"basename": "thanks.js",
				"dirname": "",
				"stem": "thanks",
				"path": "thanks.js"
			},
			"requirePath": "thanks.js",
			"path": "/thanks/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "work",
				"stem": "_template",
				"path": "work/_template.js"
			},
			"requirePath": "work/_template.js",
			"templatePath": "/work/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Basement.md",
				"ext": "md",
				"name": "Basement",
				"extname": ".md",
				"basename": "Basement.md",
				"dirname": "work",
				"stem": "Basement",
				"path": "work/Basement.md"
			},
			"requirePath": "work/Basement.md",
			"path": "/work/Basement/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Bathrooms.md",
				"ext": "md",
				"name": "Bathrooms",
				"extname": ".md",
				"basename": "Bathrooms.md",
				"dirname": "work",
				"stem": "Bathrooms",
				"path": "work/Bathrooms.md"
			},
			"requirePath": "work/Bathrooms.md",
			"path": "/work/Bathrooms/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Decks.md",
				"ext": "md",
				"name": "Decks",
				"extname": ".md",
				"basename": "Decks.md",
				"dirname": "work",
				"stem": "Decks",
				"path": "work/Decks.md"
			},
			"requirePath": "work/Decks.md",
			"path": "/work/Decks/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "detail.json",
				"ext": "json",
				"name": "detail",
				"extname": ".json",
				"basename": "detail.json",
				"dirname": "work",
				"stem": "detail",
				"path": "work/detail.json"
			},
			"requirePath": "work/detail.json",
			"path": "/work/detail/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Exterior.md",
				"ext": "md",
				"name": "Exterior",
				"extname": ".md",
				"basename": "Exterior.md",
				"dirname": "work",
				"stem": "Exterior",
				"path": "work/Exterior.md"
			},
			"requirePath": "work/Exterior.md",
			"path": "/work/Exterior/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Garage.md",
				"ext": "md",
				"name": "Garage",
				"extname": ".md",
				"basename": "Garage.md",
				"dirname": "work",
				"stem": "Garage",
				"path": "work/Garage.md"
			},
			"requirePath": "work/Garage.md",
			"path": "/work/Garage/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "work",
				"stem": "index",
				"path": "work/index.js"
			},
			"requirePath": "work/index.js",
			"path": "/work/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Kitchens.md",
				"ext": "md",
				"name": "Kitchens",
				"extname": ".md",
				"basename": "Kitchens.md",
				"dirname": "work",
				"stem": "Kitchens",
				"path": "work/Kitchens.md"
			},
			"requirePath": "work/Kitchens.md",
			"path": "/work/Kitchens/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "LivingRoom.md",
				"ext": "md",
				"name": "LivingRoom",
				"extname": ".md",
				"basename": "LivingRoom.md",
				"dirname": "work",
				"stem": "LivingRoom",
				"path": "work/LivingRoom.md"
			},
			"requirePath": "work/LivingRoom.md",
			"path": "/work/LivingRoom/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Mudroom.md",
				"ext": "md",
				"name": "Mudroom",
				"extname": ".md",
				"basename": "Mudroom.md",
				"dirname": "work",
				"stem": "Mudroom",
				"path": "work/Mudroom.md"
			},
			"requirePath": "work/Mudroom.md",
			"path": "/work/Mudroom/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Porches.md",
				"ext": "md",
				"name": "Porches",
				"extname": ".md",
				"basename": "Porches.md",
				"dirname": "work",
				"stem": "Porches",
				"path": "work/Porches.md"
			},
			"requirePath": "work/Porches.md",
			"path": "/work/Porches/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "work",
				"base": "Woodwork.md",
				"ext": "md",
				"name": "Woodwork",
				"extname": ".md",
				"basename": "Woodwork.md",
				"dirname": "work",
				"stem": "Woodwork",
				"path": "work/Woodwork.md"
			},
			"requirePath": "work/Woodwork.md",
			"path": "/work/Woodwork/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0